<app-add-reference-card
  class="btn-existing"
  desc="You have no extended warranty records."
  btnLabel="Select from existing item list"
  type="flat-button"
  icon="keyboard_return"
  tabindex="0"
  (keypress)="!isReadOnly && navigateToItemVendor()"
  (click)="!isReadOnly && navigateToItemVendor()"
  *ngIf="dataSource.data.length < 1"
  [disabled]="isReadOnly"
>
</app-add-reference-card>
<ng-container *ngIf="dataSource.data.length > 0">
  <app-button
    class="btn-existing"
    icon="keyboard_return"
    name="Select from existing item list"
    tabindex="0"
    (keypress)="!isReadOnly && navigateToItemVendor()"
    (click)="!isReadOnly && navigateToItemVendor()"
    type="flat-button"
    [disabled]="isReadOnly"
  ></app-button>
  <table
    class="mat-elevation-z8 tb-container"
    mat-table
    multiTemplateDataRows
    matSort
    [dataSource]="dataSource"
    *ngIf="dataSource.data.length > 0"
  >
    <ng-container
      matColumnDef="{{ column }}"
      *ngFor="let column of columnsToDisplay"
    >
      <div *ngIf="column === 'index'">
        <th mat-header-cell *matHeaderCellDef>Item no.</th>
      </div>
      <div *ngIf="column === 'Description'">
        <th mat-header-cell *matHeaderCellDef>Item description</th>
      </div>
      <div *ngIf="column === 'Quantity'">
        <th mat-header-cell *matHeaderCellDef>Qty</th>
      </div>
      <div *ngIf="column === 'DurationYears'">
        <th mat-header-cell *matHeaderCellDef>Years</th>
      </div>
      <div *ngIf="column === 'DurationMonths'">
        <th mat-header-cell *matHeaderCellDef>Months</th>
      </div>
      <div>
        <td
          mat-cell
          *matCellDef="let row"
        >
        <ng-container *ngIf="column==='index'">
          <ng-container
            class="item-row-hover"
            *ngIf="row.hovered && !isReadOnly && !row.Strikethrough"
          >
            <a (click)="navigateToAddItem(row)">
              <div class="row-button">
                <mat-icon title="Edit">edit</mat-icon>
                <!-- <span class="tooltip-text">Edit</span> -->
              </div>
            </a>
          </ng-container>

          <div class="item-row-no" *ngIf="!row.hovered" [ngClass]="{ 'deleted-row': row.isDeleted || row.Strikethrough}">
            {{ row[column]}}
          </div>
        </ng-container>
        <div *ngIf="column!=='index'" [ngClass]="{ 'deleted-row': row.isDeleted || row.Strikethrough}">{{row[column]}}</div>

        </td>
      </div>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay" (mouseenter)="row.hovered = true"
    (mouseleave)="row.hovered = false"></tr>
  </table>
</ng-container>
<mat-paginator
  [ngClass]="{ 'd-none': dataSource.data.length < 1 }"
  [length]="dataSource.data.length"
  [pageSizeOptions]="pageSizeOptions"
  showFirstLastButtons
></mat-paginator>
